import toastr from "toastr";
import "toastr/build/toastr.min.css";
import moment from "moment";

// conditional message expressions
export const isClientMsg = (m) => m?.by === "consumer" ?? false;
export const isAgentMsg = (m) => m?.by === "agent" ?? false;
export const isAllowedUserMsg = (m) => isAgentMsg(m) || isClientMsg(m);
export const isByEmployee = (m) => m?.by === "agent" || m?.by === "manager";
export const isPrivateMsg = (m) => m?.private ?? false;
export const isValidMsg = (m) => !isPrivateMsg(m) && isAllowedUserMsg(m);
export const isSameSender = (m, sender) => m?.by === sender ?? false;

function configureToastr() {
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: 200,
    hideDuration: 200,
    timeOut: 4000,
    extendedTimeOut: 2000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };
}

configureToastr()

// TODO: remove delay after tests. It's used during development.
export const showToast = (type, message, delay) => {
  configureToastr()
  setTimeout(() => toastr[type](message), delay);
};

export const checkInternet = async (handleConnection, setHandleConnection) => {
  try {
    //TODO: Implement this check with message api that will be created - REMOVED "https://www.google.com/"
    const urlCheckInternet = window.location.href;
    const res = await fetch(urlCheckInternet, {
      mode: "no-cors",
    });
    if (res) {
      setHandleConnection(() => ({
        status: true,
        handle: !handleConnection,
      }));
    } else {
      setHandleConnection(() => ({
        status: false,
        handle: !handleConnection,
      }));
    }
  } catch (e) {
    setHandleConnection(() => ({
      status: false,
      handle: !handleConnection,
    }));
  }
};

/**
 * Function to alter sla timer when
 * it goes through an exception so the 
 * timer only counts work days
 * 
 * @param  {[object]} chat conversation chat that 
 * has information about an singular conversation
 * @param  {[number]} delta number that shows the current 
 * conversation timer
 * 
 * @return {[number]} returns an updated value if the conversation was with an agent in an exception period.
 */
const handleDayException = (chat, delta) => {

  if(chat?.slaCount?.dayException === false && 
  chat.slaCount?.exceptionsSlaSeconds > 0){
    delta -= chat.slaCount.exceptionsSlaSeconds
  }
  return delta;
}

export const handleTimer = (messageOperator, setChats) => {
  let now = moment();

  let newChats =
    messageOperator?.chats?.data?.map((chat) => {
      let msgTime;
      let delta;

      if (chat.status !== "closed" && chat.status !== "pos-chat") {
        msgTime = moment(chat.firstWithoutAnswer?.time);
        delta = now.diff(msgTime, "seconds");
      }

      delta = handleDayException(chat, delta)

      return chat.status !== "closed" && chat.status !== "pos-chat"
        ? {
            ...chat,
            slaLate: parseInt(chat.slaLate),
            inactivityTime: parseInt(chat.inactivityTime),
            message: [],
            timer: chat.timer !== undefined
              ? parseInt(chat.timer) - 1
              : parseInt(chat.slaLate) - delta,
          }
        : chat;
    }) ?? [];

  setChats(newChats);
};
